module.exports = __webpack_public_path__ + "img/inactive-28.4ab82682.svg";